export const findUsersIds = (data: any, criteria: string[], result: string[] = []): string[] => {
  if (!data) {
    return [];
  }
  let usersIds = [...result];
  const keys = Object.keys(data);
  for (const key of keys) {
    const field = data[key];
    if (field && typeof field === 'object') {
      usersIds = [...usersIds, ...findUsersIds(field, criteria)];
    } else if (criteria.includes(key)) {
      usersIds.push(data.data?.NewId || data.id);
    }
  }
  return Array.from(new Set(usersIds));
};
